import { get } from "../GenericServices";

const WorkProgressPm = {
  getPmReport: (queryString) => {
    return get(`work-progress-pm/find?${queryString}`);
  },
  downloadPmReport: (queryString) => {
    return get(`work-progress-pm/export?${queryString}`);
  },
};

export default WorkProgressPm;
